import styled from 'styled-components'

export const PropertyListWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
`
